import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import PublicNav from '@/components/PublicNav';
import ZLoadingBar from '@/components/shared/ZLoadingBar';
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import Logotype from '@/components/shared/Logotype';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TravelsPostcards() {
  const navigate = useNavigate();
  const [postcards, setPostcards] = useState(null);

  useEffect(() => {
    document.title = 'Postcards · Werner du Toit';
    axios.get(`${API}/public/giraffe/postcards`)
      .then(r => setPostcards(Array.isArray(r.data) ? r.data : []))
      .catch(() => setPostcards([]));
  }, []);

  if (postcards === null) {
    return (
      <div className="min-h-screen bg-[#0a0a0f]">
        <ZLoadingBar accent="#10B981" loading />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0a0f] pt-4 md:pt-16 pb-20">
      <PublicNav />

      <div className="px-6 md:px-12 max-w-5xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mt-6 mb-10">
          <div>
            <p className="text-xs tracking-[0.4em] uppercase mb-2"
              style={{ fontFamily: "'Cormorant Garamond', serif", color: '#b0b4c0' }}>
              Notes From The Road
            </p>
            <h1 className="text-4xl sm:text-5xl font-black tracking-tight"
              style={{ fontFamily: "'Playfair Display', serif", color: '#f0f0f5', lineHeight: 1 }}>
              POSTCARDS
            </h1>
          </div>
          <Breadcrumb>
            <BreadcrumbList style={{ gap: 0 }}>
              <BreadcrumbItem>
                <BreadcrumbLink onClick={() => navigate('/travels')} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                  <Logotype app="giraffe" size="sidebar" />
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator style={{ padding: '0 8px', color: '#454860' }} />
              <BreadcrumbItem>
                <BreadcrumbPage style={{ color: '#f0f0f5', fontSize: 13, fontWeight: 400 }}>
                  Postcards
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {postcards.length === 0 ? (
          <p className="text-center py-16 text-[#454860] font-mono text-sm">No postcards yet.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {postcards.map(p => (
              <div
                key={p.id}
                onClick={() => navigate(`/travels/postcard/${p.public_slug || p.id}`)}
                className="group cursor-pointer overflow-hidden rounded-lg bg-white/[0.02] border border-white/[0.04] hover:border-white/[0.10] transition-all"
                data-testid={`postcard-card-${p.id}`}
              >
                <div className="aspect-[4/5] relative overflow-hidden bg-white/[0.03]">
                  {p.composed_image_url && (
                    <img
                      src={p.composed_image_url}
                      alt={p.title || ''}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  )}
                </div>
                {p.title && (
                  <div className="p-3">
                    <p className="text-sm text-[#f0f0f5] truncate" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{p.title}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="text-center py-12">
        <p className="text-xs tracking-[0.3em]" style={{ fontFamily: "'Cormorant Garamond', serif", color: 'rgba(255,255,255,0.06)' }}>
          WERNER LABS
        </p>
      </div>
    </div>
  );
}
